import { t, tn } from '../lib/i18n.js';

// Prompt-Kategorien in den Einstellungen (Prompts → Kategorien, partials/
// prompt-categories.html.twig) anlegen, umbenennen, löschen, ohne die Seite neu zu
// laden. Die Felder gehören über form="…" zu eigenen Formularen unter der
// Verwaltung; ohne JavaScript schicken diese sie ab, und die Seite lädt neu. Jede
// Antwort bringt den Stand aller Kategorien: damit zeichnet das Modul die
// Verwaltung und die Vorschläge neu - auch, was inzwischen jemand anderes geändert hat.
//
// Formulare nur über getAttribute lesen: ihre Felder heißen "action" und "id"
// und verdecken sonst form.action und form.id.
export default function promptCategories() {
  const forms = document.querySelector('[data-category-forms]');
  if (!forms) return;
  const admin = document.querySelector('[data-category-admin]');

  // Nacheinander, in der Reihenfolge der Eingaben.
  let queue = Promise.resolve();

  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-category-form')) return;
    event.preventDefault();
    // Rückfragen (data-confirm am Löschen-Knopf) stellt confirm.js vorher.
    const submitter = event.submitter;
    const data = new FormData(form);
    if (submitter && submitter.name) data.set(submitter.name, submitter.value);
    send(form, data);
  });

  function send(form, data) {
    const id = form.getAttribute('id');
    const status = admin ? admin.querySelector('[data-category-status]') : null;
    show(status, t('Speichert …'), '');
    queue = queue
      .then(function () { return post(form, data); })
      .then(function (result) {
        if (result.state) apply(result.state, id);
        show(status, result.message, result.ok ? 'is-ok' : 'is-error');
        // Angelegt - das Feld wird wieder frei.
        if (result.ok && id === 'category-create') {
          Array.from(form.elements).forEach(function (el) { if (el.type === 'text') el.value = ''; });
        }
      });
  }

  async function post(form, data) {
    let res;
    try {
      res = await fetch(form.getAttribute('action'), { method: 'POST', headers: { Accept: 'application/json' }, body: data });
    } catch (e) {
      return { ok: false, message: t('Keine Antwort vom Server – bitte erneut versuchen.') };
    }
    // Sitzung abgelaufen: zur Anmeldung, danach zurück zu den Kategorien.
    if (res.status === 401) {
      window.location.href = forms.dataset.loginUrl + '?next=' + encodeURIComponent(window.location.pathname + '#kategorien');
      return { ok: false, message: t('Nicht angemeldet.') };
    }
    // body.message kommt schon übersetzt vom Server.
    const body = await res.json().catch(function () { return null; });
    if (body && Array.isArray(body.categories)) {
      return { ok: body.ok, message: body.message, state: body };
    }
    return {
      ok: false,
      message: res.status === 419 ? t('Sitzung abgelaufen – bitte die Seite neu laden.')
        : (body && body.message) || t('Nicht gespeichert (HTTP {status}) – bitte die Seite neu laden.', { status: res.status }),
    };
  }

  function show(status, text, state) {
    if (!status) return;
    status.textContent = text;
    status.classList.remove('is-ok', 'is-error');
    if (state) status.classList.add(state);
  }

  // Stand aller Kategorien übernehmen: Vorschläge, die Verwaltung.
  function apply(state, sourceId) {
    const list = document.getElementById('category-names');
    if (list) {
      const known = state.categories.map(function (c) { return c.name.toLowerCase(); });
      const suggestions = JSON.parse(list.dataset.suggestions || '[]').filter(function (name) {
        return !known.includes(name.toLowerCase());
      });
      list.replaceChildren(...state.categories.map(function (c) { return c.name; }).concat(suggestions).map(function (name) {
        const option = document.createElement('option');
        option.value = name;
        return option;
      }));
    }
    if (admin) updateAdmin(state, sourceId);
  }

  function updateAdmin(state, sourceId) {
    const rows = admin.querySelector('[data-category-rows]');
    if (!rows) return;

    const existing = {};
    rows.querySelectorAll('tr[data-category-row]').forEach(function (tr) { existing[tr.dataset.categoryRow] = tr; });
    const wanted = state.categories.map(function (c) {
      const formId = 'category-' + c.id;
      ensureForm(formId, c.id);
      const tr = existing[c.id] || row(c, formId);
      const input = tr.querySelector('input[name="name"]');
      // Einen gerade getippten Namen stehen lassen - außer in der Zeile, die gespeichert hat.
      if (input.value === input.dataset.saved || formId === sourceId) input.value = c.name;
      input.dataset.saved = c.name;
      input.setAttribute('aria-label', t('Name der Kategorie {name}', { name: c.name }));
      tr.querySelector('[data-category-count]').textContent = String(c.prompts);
      tr.querySelector('button[value="delete"]').dataset.confirm = c.prompts > 0
        ? tn('Kategorie „{name}“ löschen? Sie wird bei {count} Prompt entfernt.|Kategorie „{name}“ löschen? Sie wird bei {count} Prompts entfernt.', c.prompts, { name: c.name })
        : t('Kategorie „{name}“ löschen?', { name: c.name });
      return tr;
    });
    if (wanted.length === 0) {
      const empty = element('tr', '', '');
      const cell = element('td', 'muted', t('Noch keine Kategorien.'));
      cell.colSpan = 3;
      empty.append(cell);
      rows.replaceChildren(empty);
    } else if (!sameChildren(rows, wanted)) {
      rows.replaceChildren(...wanted);
    }

    // Formulare gelöschter Kategorien entfernen.
    const ids = state.categories.map(function (c) { return 'category-' + c.id; });
    forms.querySelectorAll('form').forEach(function (form) {
      const id = form.getAttribute('id') || '';
      if (/^category-\d+$/.test(id) && !ids.includes(id)) form.remove();
    });
  }

  function row(c, formId) {
    const tr = document.createElement('tr');
    tr.dataset.categoryRow = String(c.id);
    const input = document.createElement('input');
    input.type = 'text';
    input.name = 'name';
    input.maxLength = 200;
    input.autocomplete = 'off';
    input.setAttribute('form', formId);
    input.value = c.name;
    input.dataset.saved = c.name;
    const name = element('td', '', '');
    name.append(input);
    const count = element('td', 'num', String(c.prompts));
    count.dataset.categoryCount = '';
    const actions = element('td', 'action', '');
    actions.append(button(t('Umbenennen'), 'btn btn-small', formId, 'rename'), document.createTextNode(' '),
      button(t('Löschen'), 'btn btn-small btn-danger', formId, 'delete'));
    tr.append(name, count, actions);
    return tr;
  }

  function ensureForm(formId, categoryId) {
    if (document.getElementById(formId)) return;
    const form = document.createElement('form');
    form.setAttribute('id', formId);
    form.setAttribute('method', 'post');
    form.setAttribute('action', forms.dataset.action);
    form.setAttribute('data-category-form', '');
    form.append(hidden('_token', forms.dataset.token), hidden('id', String(categoryId)));
    forms.append(form);
  }

  function hidden(name, value) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    return input;
  }

  function button(text, className, formId, action) {
    const el = element('button', className, text);
    el.type = 'submit';
    el.name = 'action';
    el.value = action;
    el.setAttribute('form', formId);
    return el;
  }

  function element(tag, className, text) {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (text) el.textContent = text;
    return el;
  }

  function sameChildren(parent, nodes) {
    return parent.children.length === nodes.length && nodes.every(function (node, i) { return parent.children[i] === node; });
  }
}
